<template>
  <div>
    <Header state="home" />
    <div class="hero text-center">
      <h2>{{hero.title}}</h2>
      <p>{{hero.forText}}</p>
      <div>
        <button class="btn btn-primary" @click="goToAccount">Get started!</button>
      </div>
    </div>
    <div class="">
      <ul class="pros-list columns">
        <li class="pro column col-md-12 col-lg-4 col-mx-auto">
          <Pro
            iconClass="fa-tags text-red"
            title="100% Free"
            text="There is no hidden costs, what you see is what you get, everything is free." />
        </li>
        <li class="pro column col-md-12 col-lg-4 col-mx-auto">
          <Pro
            iconClass="fa-database text-green"
            title="Your data is safe"
            text="Data is kept on your current device. The ability to sync with other devices is coming soon." />
        </li>
        <li class="pro column col-md-12 col-lg-4 col-mx-auto">
          <Pro
            iconClass="fa-line-chart text-blue"
            title="All coins are supported"
            text="You can add known or upcoming cryptocurrencies here and track your asset worth." />
        </li>
      </ul>
    </div>
    <!-- <div class="create-wallet text-center">
      <h4>Create your wallet</h4>
      <p>Use the button below to start add your investments!</p>
      <button class="btn btn-primary">Get started!</button>
    </div> -->
  </div>
</template>

<script>
import Router from '@/router';
import Header from '@/components/header/Header';
import Pro from '@/components/home/Pro';

export default {
  name: 'Home',
  components: {
    Header,
    Pro,
  },
  data() {
    return {
      hero: {
        title: 'Your Cryptocurrency tracker',
        forText: 'Fill in your initial investments, and watch your net worth automatically update based on the latest cryptocurrency prices.',
        psText: 'PS: it is free, and all the data is only stored on your current device.',
      },
    };
  },
  methods: {
    goToAccount() {
      Router.push({ name: 'Account' });
    },
  },
};
</script>

<style lang="scss" scoped>
  div.hero {
    display: flex;
    flex-direction: column;
    margin: 3rem 1rem;

    button {
      background: #673AB7;
      margin-bottom: 1rem;
    }
  }

  ul.pros-list {
    margin: 0 0 2rem 0;

    li.pro {
      list-style: none;
      padding: 1rem;
    }
  }

  div.create-wallet {
    margin: 0 1rem 1.5rem 1rem;

    button {
      background: #673AB7;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/Home.vue